import { combineReducers } from 'redux'
import { projectReducer, ProjectState } from './project/project-reducer'
import { combineEpics } from 'redux-observable'
import { objectActions } from './object/object-actions'
import { objectReducer, ObjectState } from './object/object-reducer'
import { taskReducer, TaskState } from './task/task-reducer'
import { tagActions, tagEpic, tagReducer, TagState } from './tag'
import { projectActions } from './project/project-actions'
import { projectEpic } from './project/project-epic'
import { objectEpic } from './object/object-epics'
import { taskActions } from './task/task-actions'
import { taskEpic } from './task/task-epic'
import { usersActions, usersReducer, UsersState } from './users'

export const dataActions = {
    objectActions,
    projectActions,
    tagActions,
    taskActions,
    usersActions,
}

export interface DataState {
    object: ObjectState,
    project: ProjectState,
    tag: TagState,
    task: TaskState,
    users: UsersState,
}

export const dataReducer = combineReducers<DataState>({
    object: objectReducer,
    project: projectReducer,
    tag: tagReducer,
    task: taskReducer,
    users: usersReducer,
})

export const dataEpic = combineEpics(objectEpic, projectEpic, tagEpic, taskEpic)